
import React, { useState } from "react";
import liveChat from "../live-chat.png";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-hot-toast";

function SignUp({ isSubmitting = false, error = "" }) {
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [localError, setLocalError] = useState("");
    const navigate = useNavigate();
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLocalError("");

        if (!username || !email || !password || !confirmPassword) {
            setLocalError("Please fill in all fields");
            toast.error("Please fill in all fields");
            return;
        }
        if (password.length < 6) {
            setLocalError("Password must be at least 6 characters");
            toast.error("Password must be at least 6 characters");
            return;
        }
        if (password !== confirmPassword) {
            setLocalError("Passwords do not match");
            toast.error("Passwords do not match");
            return;
        }

        try {
            const data = await axios.post("https://pingify-47gx.onrender.com/api/v1/auth/register", { username, email, password })
            console.log("Registration API Status...", data);
            toast.success("Account created successfully. Please log in.");
            navigate("/");
        } catch (err) {
            console.log("Error on Signup Form...")
            const msg = err?.response?.data?.message || "Signup failed. Please try again.";
            toast.error(msg);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-black p-6">
            <div className="bg-gray-900 p-8 rounded-xl shadow-lg w-full max-w-md text-white">
                <div className="text-center mb-6">
                    <img src={liveChat} alt="Pingify" className="mx-auto w-20 h-20 mb-4" />
                    <h1 className="text-3xl font-bold">Create your account</h1>
                    <p className="text-gray-400 mt-2">Join Pingify in seconds</p>
                </div>

                {(localError || error) && (
                    <div className="mb-4 text-red-400 text-sm bg-red-900/30 border border-red-800 rounded p-2">
                        {localError || error}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-4">
                    <input
                        className="w-full px-4 py-2 rounded-md bg-black border border-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-white"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        autoComplete="username"
                    />
                    <input
                        type="email"
                        className="w-full px-4 py-2 rounded-md bg-black border border-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-white"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        autoComplete="email"
                    />
                    <input
                        type="password"
                        className="w-full px-4 py-2 rounded-md bg-black border border-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-white"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="new-password"
                    />
                    <input
                        type="password"
                        className="w-full px-4 py-2 rounded-md bg-black border border-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-white"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        autoComplete="new-password"
                    />

                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full bg-white text-black py-2 rounded-md font-semibold hover:bg-gray-300 transition disabled:opacity-60 disabled:cursor-not-allowed"
                    >
                        {isSubmitting ? "Creating account..." : "Sign Up"}
                    </button>
                </form>
                <div className="mt-4 text-sm text-gray-400 text-center">
                    Already a user? <Link to="/" className="text-white underline">Log in</Link>
                </div>
            </div>
        </div>
    );
}

export default SignUp;
